const ROUTES = {
  ROOT: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  HOME: "/home",
  LISTINGS: "/room-listings",
  LISTING_DETAILS: "/room-listings/:id",
  CREATE_LISTING: "/post-room",
  EDIT_LISTING: "/edit-listing/:id",
  MY_LISTINGS: "/my-posts",
  SHORTLIST: "/shortlist",
  PROFILE: "/profile",
  EDIT_PROFILE: "/edit-profile",
  COMPLETE_PROFILE: "/complete-profile",
  NAFATH_VERIFICATION: "/nafath-verification",
  VERIFICATION_INFO: "/verification-info",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_CONDITIONS:"/terms-conditions",
  NOT_FOUND: "*",
};

export default ROUTES;